import { SIDEBAR_BG, THEME } from "./env.action";

export const setSidebarBg = (payload) => {
  return {
    type: SIDEBAR_BG,
    payload,
  };
};

export const setTheme = (payload) => {
  return {
    type: THEME,
    payload,
  };
};
